<template>
    <v-data-table-server
        :headers="datatable.headers"
        :items="datatable.records.value"
        :loading="datatable.loading.value"
        :sort-by="datatable.sortBy.value"
        @update:sortBy="datatable.onSort"
        :density="tableCard.tableDensity.value"
        hide-default-footer

        v-model:items-per-page="datatable.request.length"
        :items-length="datatable.totalRecords.value"
        :items-per-page-options="datatable.itemsPerPageOptions"
        :page="datatable.currentPage.value"
        @update:page="datatable.onUpdatePage"
        @update:items-per-page="datatable.onUpdateItemsPerPage"
        :hover="true"
        show-current-page
        v-model="datatable.selectedRows.value"
        ref="dtRef"
        :show-select="datatable.config.value.ability?.selection"
        select-strategy="all"
        item-selectable="selectable"
        :class="{
            'flex-grow-1': true,
            'datatable-server': true,
            'table-has-no-data': !(datatable.records?.value?.length),
            'table-full-page': tableCard.isFullPage.value,
        }"
    >
        <template v-for="header in datatable.headers" :key="header.key" v-slot:[`item.${header.key}`]="{ item }">
            <template v-if="$slots[`item.${header.key}`]">
                <slot :name="`item.${header.key}`" :item="item" :value="item[header.key ?? ''] ?? ''" ></slot>
            </template>
            <template v-else-if="header.headerProps?.hasHtml">
                <div v-html="item[header.key ?? ''] ?? ''"></div>
            </template>
            <template v-else>
                {{ item[header.key ?? ''] ?? '' }}
            </template>
        </template>

        <template #no-data>
            <div class="table-rows-no-data-text">No data available</div>
        </template>
        <template #bottom v-if="datatable.config.value.ability?.footer">
            
            <div class="v-data-table-footer-wrapper d-flex flex-wrap ga-2" :class="[tableCard.card.footerClass]">
                <v-pagination
                    v-model="datatable.currentPage.value"
                    :length="datatable.totalPage.value"
                    @update:model-value="datatable.onUpdatePage"
                    :total-visible="tableCard.paginationItemCount.value"
                    density="compact"
                    showFirstLastPage
                    v-if="datatable.config.value.ability?.pagination"
                />
                <v-data-table-footer
                :items-per-page.sync="datatable.request.length"
                :items-per-page-options="datatable.itemsPerPageOptions"
                :items-length="datatable.totalRecords.value"
                :data-all-total-records="`(Filtered from ${datatable.allTotalRecords.value} total records)`"
                :page.sync="datatable.currentPage.value"
                :show-current-page="true"
                :show-rows-per-page="true"
                items-per-page-text="Per page"
                v-if="datatable.config.value.ability?.length"
                :class="{'has-diff-total': !tableCard.isFullPage.value && datatable.allTotalRecords.value != datatable.totalRecords.value}"
                ></v-data-table-footer>
            </div>
            <div class="text-center pt-1" v-if="datatable.selectedRows.value?.length">
                <span class="fw-medium">(Selected {{ datatable.selectedRows.value.length }})</span> The checkbox in header doesn't mean select all accross pages, it only selects all of the current page.
            </div>
        </template>
    </v-data-table-server>
</template>
<script setup lang="ts">
    import { ref, Ref, PropType, toRefs, onMounted } from "vue";
    import { useDatatable, Datatable, UseDatatableReturn } from '@/Composables/Datatable';
    import { useDomHighlighter } from '@/Composables/DomHighlighter';
    import { pageTitle, useTableCard } from '@/Composables/PageMeta';
    const props = defineProps({
        datatable: {
            type: Object as PropType<UseDatatableReturn>,
            required: true
        },
        tableCard: {
            type: Object as PropType<ReturnType<typeof useTableCard>>,
            required: false
        },
        fullPage:{
            type: Boolean,
            required: false,
        }
    });
    const dtRef = ref<HTMLElement | null>(null);
    const { datatable } = toRefs(props);
    console.log('datatable', datatable)
    const tableCard = props?.tableCard ?? useTableCard({
        fullPage: props?.fullPage ?? false
    });
    
    onMounted(() => {
        const {highlightTextFromRef} = useDomHighlighter();
        datatable.value.afterDefault.value = () => {
            if(datatable.value.config.value.ability?.highlight?.enable){
                highlightTextFromRef(dtRef, datatable.value.request.search.value ?? '', {
                    className: 'dt-search-highlight',
                    highlightAll: datatable.value.config.value.ability?.highlight?.full ?? true,
                });
            }
        }
        datatable.value.afterDefault.value();
        // console.log('dtref', dtRef)
    })
</script>